import { ApolloError } from '@apollo/client/errors';

// Callers pass whatever their `catch` received; a non-Apollo throw (reCAPTCHA, a hook) has no
// `graphQLErrors`, and crashing here hid the real message behind a `reduce` TypeError.
export const extractValidationErrors = (error: ApolloError): Record<string, string> =>
  (error?.graphQLErrors ?? []).reduce((acc, currValue) => {
    const res = { ...acc };

    if (currValue?.extensions?.code === 'BAD_USER_INPUT') {
      // @ts-ignore
      (currValue.extensions.response as any)?.message?.forEach(({ field, message }) => {
        // @ts-ignore
        res[field] = message;
      });
    }

    if (currValue?.extensions?.code === 'BAD_REQUEST') {
      // @ts-ignore
      (currValue.extensions.originalError as any)?.message?.forEach(({ field, message }) => {
        // @ts-ignore
        res[field] = message;
      });
    }

    return res;
  }, {});
